/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _assign = _interopRequireDefault(require("../../../common/assign"));
var _reactClass = _interopRequireDefault(require("../../../packages/react-class"));
var _join = _interopRequireDefault(require("../../../common/join"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var MenuSeparator = function (_Component) {
  (0, _inherits2.default)(MenuSeparator, _Component);
  var _super = _createSuper(MenuSeparator);
  function MenuSeparator() {
    (0, _classCallCheck2.default)(this, MenuSeparator);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(MenuSeparator, [{
    key: "render",
    value: function render() {
      var props = this.prepareProps(this.props);
      return _react.default.createElement("tr", {
        className: props.className
      }, _react.default.createElement("td", {
        colSpan: 100
      }, _react.default.createElement("div", {
        className: "".concat(props.rootClassName, "__menu-separator__tool"),
        style: props.style
      })));
    }
  }, {
    key: "prepareProps",
    value: function prepareProps(thisProps) {
      var props = {};
      (0, _assign.default)(props, thisProps);
      props.style = this.prepareStyle(props);
      props.className = this.prepareClassName(props);
      return props;
    }
  }, {
    key: "prepareClassName",
    value: function prepareClassName(props) {
      var className = (0, _join.default)("".concat(props.rootClassName, "__menu-separator"), props.className);
      return className;
    }
  }, {
    key: "prepareStyle",
    value: function prepareStyle(props) {
      return (0, _assign.default)({}, props.style, props.menuSeparatorStyle);
    }
  }]);
  return MenuSeparator;
}(_reactClass.default);
MenuSeparator.defaultProps = {
  isSeparator: true
};
var _default = MenuSeparator;
exports.default = _default;